<template>
	<div class="page">
		<div class="searchBox">
			<el-row>
				<el-col :span="4" >
					<span style="font-size: 18px;font-weight: bold;line-height: 40px;">编辑药品</span>
				</el-col>
				<el-col :span="8" :offset="12" style="text-align: right;">
					<el-button style="width:100px;" type="primary" :loading="loading" @click='submit'>提交</el-button>
					<el-button type="warning" @click="isBack" >返回</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="con">
			<el-form ref="ruleForm" label-width="150px" class="demo-ruleForm">
				<div class="tit">
					<span class="name">基础设置</span>
				</div>
				<el-form-item label="药品分类" class="formitem" v-if="treeList.length > 0">
					<el-cascader size="mini" filterable ref="cascader" v-model="productTypeIds" :options="treeList[0].children" :show-all-levels="true" :props="{ label: 'label',value:'id' }" @change="changeCategory" style="width:350px;" placeholder="药品分类"></el-cascader>
				</el-form-item>
				<el-form-item label="品牌名:" class="formitem mandatory" prop="brand_name">
					<el-select class="input" v-model="editParams.brand_name" filterable placeholder="品牌名" size="mini" style="width:350px;">
						<el-option :label="item.name" :value="item.name" v-for="item in brandList" :key="item._id" >
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="适用品种" class="formitem" prop="category_of">
					<el-radio-group v-model="editParams.applyType">
						<el-radio label="0">通用</el-radio>
						<el-radio label="1">猫用</el-radio>
						<el-radio label="2">犬用</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="药品名称" class="formitem" >
					<el-input v-model="editParams.title" size="mini" style="width: 350px;" placeholder="药品名称"></el-input>
				</el-form-item>
				<el-form-item label="医学名称" class="formitem"  >
					<el-input v-model="editParams.medical_name" size="mini" style="width: 350px;" placeholder="医学名称"></el-input>
				</el-form-item>
				<el-form-item label="打印名称" >
					<el-input v-model="editParams.other_name" size="mini" style="width: 350px;" placeholder="打印名称"></el-input>
				</el-form-item>
				<storeSelect v-if="storeSelect_state" title='应用门店' :storeIds='storeIds' @sendStore='(d)=>{editParams.shop_info = d}'></storeSelect>
				<div class="tit">
					<span class="name">其他</span>
				</div>
				
				<!-- <el-form-item label="规格名称" class="formitem">
					<el-input v-model="editParams.old_packinfo_info.sku_value" size="mini" style="width: 350px;" placeholder="规格名称"></el-input>
				</el-form-item> -->
				
				<div style="padding:0 0 20px 0;border-bottom:1px double #aaa;margin-bottom:20px;">
					<el-form-item label="药品售卖规格 " class="formitem">
						<el-input v-model="editParams.old_packinfo_info.in_exchanage" @input="inputInExchange" size="mini" style="width: 100px;" placeholder="数量"></el-input>
						<!-- <el-input-number size="mini" v-model="editParams.old_packinfo_info.in_exchanage" @change="inexChanage" style="width: 100px;" :min="0"></el-input-number> -->
						<el-select filterable style="width: 100px;margin-left: 10px;" size='mini' v-model="editParams.old_packinfo_info.unit" placeholder="单位名称">
							<el-option v-for="item in unitData.orderUnit" :key="item.name" :label="item.name" :value="item.name">
							</el-option>
						</el-select>
						<span style="padding:0 6px;">每</span>
						<el-select filterable style="width: 100px;" size='mini' v-model="editParams.old_packinfo_info.in_unit" placeholder="单位名称">
							<el-option v-for="(item,num) in unitData.inUnit" :key="num" :label="item.name" :value="item.name">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="净含量" class="formitem">
						<!-- <el-input  size="mini" v-model="editParams.old_packinfo_info.unit_changesrc" style="width: 100px;" placeholder="1支"></el-input> -->
						1
						{{editParams.old_packinfo_info.unit}}
						=
						<el-input size="mini" v-model="editParams.old_packinfo_info.unit_changedesc" style="width: 100px;" placeholder="100ug"></el-input>
						<span style="padding-left:10px;">( 仅用于展示，不用作计算 )</span>
					</el-form-item>
					<el-form-item label="销售价" class="formitem">
						<el-input v-model="editParams.pprice" @input="inputPPrice" size="mini" style="width: 350px;" placeholder="销售价"></el-input> 元 / {{editParams.old_packinfo_info.in_unit}}
					</el-form-item>
					<el-form-item label="售卖方式" class="formitem" prop="allow_wholesale">
						<el-radio-group v-model="editParams.medical_ext_info.allow_wholesale" @change="(e)=>{e===0?editParams.medical_ext_info.use_times=editParams.old_packinfo_info.in_exchanage:editParams.medical_ext_info.use_times=1}">
							<el-radio :label="Number(1)">
								按{{editParams.old_packinfo_info.in_unit}}卖
								<span >
									( {{Number(editParams.pprice)}}元/{{editParams.old_packinfo_info.in_unit}} )
								</span>
							</el-radio>
							<el-radio :label="Number(0)">
								按{{editParams.old_packinfo_info.unit}}卖
								<span >
									( {{$public.chu(Number(editParams.pprice),Number(editParams.old_packinfo_info.in_exchanage))}}元/{{editParams.old_packinfo_info.unit}} )
								</span>
							</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="可用次数" class="formitem" >
						<el-input-number  size="mini" v-model="editParams.medical_ext_info.use_times" :disabled="editParams.medical_ext_info.allow_wholesale===0" :step-strictly="true" :min="0" style="width: 150px;"></el-input-number> 次 / {{editParams.old_packinfo_info.in_unit}}
					</el-form-item>
					<el-form-item label="用量向上取整" class="formitem" prop="dosage_ceiling" >
						<el-radio-group v-model="editParams.medical_ext_info.dosage_ceiling" @change="(e)=>{e===1?editParams.medical_ext_info.dosage_ceiling_value=0.1:editParams.medical_ext_info.dosage_ceiling_value=0}">
							<el-radio :label="Number(1)">取整</el-radio>
							<el-radio :label="Number(0)">不取整</el-radio>
						</el-radio-group>
						<span style="padding-left:10px;">( 若取整，请输入临界值 )</span>
					</el-form-item>
					<el-form-item label="向上取整临界值" class="formitem"  v-if="editParams.medical_ext_info.dosage_ceiling==1">
						<el-input-number size="mini" v-model="editParams.medical_ext_info.dosage_ceiling_value" :min="0" style="width: 150px;"></el-input-number>
					</el-form-item>
					<el-form-item label="时效性 " class="formitem">
						<el-input size="mini" v-model="editParams.medical_ext_info.time_useable" @input="inputTimeUseable" style="width: 150px;"></el-input>
						分钟
						<span style="padding-left:10px;">( 默认0，表示没有时效性 )</span>
					</el-form-item>
					<el-form-item label="是否复购" class="formitem">
						<el-radio-group v-model="editParams.buy_back">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="状态" v-if="!$public.isNull($route.query.id)" class="formitem">
						<el-radio-group v-model="editParams.status">
							<el-radio :label="1">启用</el-radio>
							<el-radio :label="0">暂停</el-radio>
							<el-radio :label="-1">作废</el-radio>
						</el-radio-group>
					</el-form-item>
				</div>
				<el-form-item label="采购进货规格" class="formitem" prop="out_unit">
					<el-input size="mini" v-model="editParams.old_packinfo_info.guige_exchanage_min" @input="inputGuigeExchanage_min" style="width: 100px;" placeholder="数量"></el-input>
					<el-select filterable style="width: 100px;margin-left: 10px;" size='mini' v-model="editParams.old_packinfo_info.guige_unit_min" placeholder="单位名称">
						<el-option v-for="(item,key) in unitData.orderUnit" :key="key" :label="item.name" :value="item.name">
						</el-option>
					</el-select>
					<span style="padding:0 6px;">每</span>
					<el-select filterable style="width: 100px;" size='mini' v-model="editParams.old_packinfo_info.guige_unit_max" placeholder="单位名称">
						<el-option v-for="(item,index) in unitData.inUnit" :key="index" :label="item.name" :value="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="最小库存预警 " prop="min_stock" class="formitem">
					<el-input v-model.number="editParams.stock_alert" size="mini" style="width: 150px;" placeholder="请输入库存下限"></el-input>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>
<script>
	import storeSelect from "../../../components/storeSelect.vue"
	export default {
		components: { storeSelect, },
		data() {
			return {
				// 分类
				productTypeIds: [],
				treeList: [],
				// 品牌
				brandList: [],
				// 适用门店
				storeIds: [],
				storeSelect_state:false,
				
				editParams: {
					medical_id: '',
					category_info: {
						_id: '',
						name: '',
						code: '',
					},
					buy_back:1,
					category_list: [],
					brand_name: '',   // 品牌名
					applyType: '0',   // 0通用   1猫  2狗
					title: '',
					medical_name: '',
					other_name: '',
					pprice: '',
					old_packinfo_info: {
						guige_exchanage_min: 1,
						guige_unit_min: '瓶',
						guige_unit_max: '箱',
						unit_changesrc: '',
						unit_changedesc: '',
						in_unit: '瓶',
						in_exchanage: 1,
						unit: 'ml',
						out_exchanage: 0,
						out_unit: '',
						sku_value:'',
					},
					medical_ext_info: {
						allow_wholesale: 1,
						dosage_ceiling: 0,
						dosage_ceiling_value: 0,
						use_times: 1,
						time_useable: 0,
					},
					stock_alert: 1,
					remark: '',
					shop_info: [],
					status:1
				},
				
				unitData: {
					inUnit: [],
					outUnit: [],
					orderUnit: [],
				},
				
				loading: false,
			}
		},
		created() {
			this.getTree();
			this.getBrandList()
			this.getUnitList();
			if (this.$route.query.id) {
				this.getProductMedicalDl(this.$route.query.id)
			} else {
				this.storeIds = this.$store.state.allShopList.map(item => {  // 默认全部门店
					return item.shop_id
				})
				this.storeSelect_state = true
				this.editParams.shop_info = this.$store.state.allShopList    // 默认全部门店
			}
		},
		methods: {
			isBack() {
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.back()
				})
			},
			// 修改药品分类 tree
			changeCategory(val) {
				if (val.length > 0) {
					this.$http.get(process.env.VUE_APP_baseData+'/api/dict/ProductType/codemodel', { id: val[val.length - 1] }).then(res => {
						if (res.code == 0) {
							this.editParams.category_info._id = res.data._id;
							this.editParams.category_info.name = res.data.name;
							this.editParams.category_info.code = res.data.code;
							this.editParams.category_list = res.data.parent_all;
						}
					})
				}
			},
			// inexChanage(val) {
			// 	if (this.params.allow_wholesale == 0) {
			// 		this.editParams.old_packinfo_info.out_exchanage = val;
			// 	}
			// },
			// 药品价格
			inputPPrice(e){
				this.editParams.pprice = this.$public.FFloat(e)
			},
			// 售卖单位
			inputInExchange(e){
				this.editParams.old_packinfo_info.in_exchanage = this.$public.FFloat(e)
				if(this.editParams.medical_ext_info.allow_wholesale===0){
					this.editParams.medical_ext_info.use_times=this.editParams.old_packinfo_info.in_exchanage
				}
			},
			// 时效性
			inputTimeUseable(e){
				this.editParams.medical_ext_info.time_useable = this.$public.FFloat(e)
			},
			// 采购单位
			inputGuigeExchanage_min(e){
				this.editParams.old_packinfo_info.guige_exchanage_min = this.$public.FFloat(e)
			},
			
			submit() {
				this.editParams.old_packinfo_info.sku_value = this.editParams.old_packinfo_info.in_exchanage+this.editParams.old_packinfo_info.unit+'/'+this.editParams.old_packinfo_info.in_unit
				this.editParams.medical_ext_info.time_useable = parseFloat(this.editParams.medical_ext_info.time_useable)
				this.loading = true;
				if(this.$public.isNull(this.editParams.category_info._id)){
					this.$message({
						message: '药品分类不能为空',
						type: 'error'
					});
					this.loading = false;
					return ;
				}
				if(this.$public.isNull(this.editParams.brand_name)){
					this.$message({
						message: '品牌不能为空',
						type: 'error'
					});
					this.loading = false;
					return ;
				}
				if(this.$public.isNull(this.editParams.title)){
					this.$message({
						message: '药品名称不能为空',
						type: 'error'
					});
					this.loading = false;
					return ;
				}
				if(this.$public.isNull(this.editParams.pprice)){
					this.$message({
						message: '销售价不能为空',
						type: 'error'
					});
					this.loading = false;
					return ;
				}
				this.$confirm(
					"<div>名称："+this.editParams.brand_name+this.editParams.title+(this.editParams.buy_back===1?' 复购':'')+"</div>"+
					"<div>价格："+(this.editParams.medical_ext_info.allow_wholesale===1?this.editParams.pprice:this.$public.chu(this.editParams.pprice,this.editParams.old_packinfo_info.in_exchanage))+"元/"+(this.editParams.medical_ext_info.allow_wholesale===1?this.editParams.old_packinfo_info.in_unit:this.editParams.old_packinfo_info.unit)+"</div>"+
					"<div>每"+this.editParams.old_packinfo_info.in_unit+"可使用"+this.editParams.medical_ext_info.use_times+"次</div>",
					'请再次确认以下药品信息',
					{
						dangerouslyUseHTMLString: true,
						confirmButtonText: '确认无误，并提交',
						cancelButtonText: '设置错误，立即修改',
						type: 'info'
					}
				).then(() => {
					this.$http.post(process.env.VUE_APP_baseData+'/api/product/medical/update', this.editParams).then(res => {
						this.loading = false;
						if (res.code == 0) {
							this.$message({
								message: '设置成功',
								type: 'success'
							});
							this.$router.back()
						}
					})
				}).catch(()=>{
					this.loading = false;
				})
			},
			getProductMedicalDl(id){
				this.$http.get(process.env.VUE_APP_baseData+'/api/product/medical', { id }).then(res=>{
					if(res.code==0){
						this.productTypeIds =[];
						this.editParams = res.data;
						res.data.category_list.forEach((item, index) => {
							if (index > 0) {
								this.productTypeIds.push(item._id)
							}
						})
						this.productTypeIds.push(res.data.category_info._id);
						this.storeIds = this.editParams.shop_info.map(item => {
							return item.shop_id
						})
						this.storeSelect_state = true
					}
				})
			},
			getTree() {
				this.$http.get(process.env.VUE_APP_baseData+'/api/dict/ProductType/tree', { category: '医疗' }).then(res => {
					if (res.code == 0) {
						this.treeList = res.data;
					}
				})
			},
			getBrandList() {
				this.$http.post(process.env.VUE_APP_baseData+'/api/dict/BrandInfo/list', {
					keyword:'',
					pageIndex: 0,
					pageSize: 0
				}).then(res => {
					this.brandList = res.data.data;
				})
			},
			getUnitList() {
				this.$http.get(process.env.VUE_APP_baseData+'/api/dict/UnitType/type/list', {}).then(res => {
					if (res.code == 0) {
						res.data.forEach(item => {
							this.$http.post(process.env.VUE_APP_baseData+'/api/dict/UnitType/list', { unitType: item }).then(response => {
								if (item == '入库单位') {
									this.unitData.inUnit = response.data.data;
								} else if (item == '出库单位') {
									this.unitData.outUnit = response.data.data;
								} else if (item == '销售单位') {
									this.unitData.orderUnit = response.data.data;
								}
							})
						})
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.page {
		padding: 10px 16px 16px 16px;
		height: 100%;
		box-sizing: border-box;
		position: relative;
		.searchBox {
			.el-form-item {
				margin-bottom: 0;
			}
		}
		.con{
			height: calc(100% - 47px);margin-top:10px;background-color: #fff;border-radius: 8px;padding:10px;box-sizing: border-box;position: relative;overflow: auto;
		}
		.tit {
			font-size: 16px;
			margin-bottom: 28px;
			background-color: #f5f5f5;
			height: 40px;
			line-height: 40px;
			border-radius: 3px;
			padding-left: 10px;

			.name {
				padding-left: 5px;
				border-left: 2px solid #F5882A;
			}
		}

		.formitem {
			margin-bottom: 0px;
		}
		
		.footer {
			background-color: #f5f5f5;
			position: fixed;
			bottom: 0;
			height: 50px;
			line-height: 50px;
			display: flex;
			justify-content: space-between;
			left: 140px;
			right: 0;
			padding-left: 20px;
			z-index: 200;
		}
	}
</style>
